import SVG from "react-inlinesvg";
import { cn } from "src/lib/cn";
import { getStyleExampleSrc } from "./lib/styleExamples";
import { composerChromeButtonClassName } from "src/lib/composerChrome";
import StyleThumbnail from "./StyleThumbnail";
import type { StylePresetOption } from "./lib/types";

interface SelectedStylePillsProps {
  stylePresets: StylePresetOption[] | null;
  selectedStyleIds: string[];
  onRemoveStyle: (styleId: string) => void;
  disabled?: boolean;
}

export default function SelectedStylePills({ stylePresets, selectedStyleIds, onRemoveStyle, disabled }: SelectedStylePillsProps) {
  if (!stylePresets) return null;
  return (
    <>
      {selectedStyleIds.map((id) => {
        const preset = stylePresets.find((p) => p.id === id);
        if (!preset) return null;
        const hasThumbnail = !!getStyleExampleSrc(id);
        return (
          <button
            key={id}
            type="button"
            disabled={disabled}
            aria-label={`Remove ${preset.label}`}
            onClick={() => onRemoveStyle(id)}
            className={cn(composerChromeButtonClassName, "group border-transparent pr-2 !text-app-grey-0", hasThumbnail ? "pl-[3px]" : "pl-2 pr-1")}
          >
            {hasThumbnail && (
              <span className="relative flex size-5 shrink-0">
                <StyleThumbnail
                  styleId={id}
                  size={20}
                />
                <span
                  aria-hidden="true"
                  className="absolute inset-0 hidden items-center justify-center rounded-[5px] bg-black/55 group-hover:flex group-focus-visible:flex group-disabled:hidden"
                >
                  <SVG
                    src="/assets/close.svg"
                    width={10}
                    height={10}
                    className="[&_path]:fill-white"
                  />
                </span>
              </span>
            )}
            <span className="whitespace-nowrap">{preset.label}</span>
            {!hasThumbnail && (
              <span
                aria-hidden="true"
                className="flex size-4 shrink-0 items-center justify-center rounded-full bg-[color-mix(in_srgb,currentColor_12%,transparent)] transition-colors group-hover:bg-[color-mix(in_srgb,currentColor_22%,transparent)]"
              >
                <SVG
                  src="/assets/close.svg"
                  width={8}
                  height={8}
                  className="[&_path]:fill-current"
                />
              </span>
            )}
          </button>
        );
      })}
    </>
  );
}
